import * as React from 'react';
import { useSelector } from 'react-redux';
import { useScrollToBlock } from '../../Scrolling';
import { EScrollingBlocks } from '../../../constants/scrollingBlocks';
import { useIsReportStatusDefault } from '../../../utils/report';
import { selectIsDesktop, selectQueryParams } from '../../../selectors/page';
import { scrollingContext } from '../../Scrolling/context';
import { selectIsSuburban } from '../../../selectors/filters';
import { useIsSearcherFromOfferCard } from '../../../utils/report/useIsSearcherFromOfferCard';

function useGetScrollBlock() {
  const { anchor } = useSelector(selectQueryParams);
  const isSuburban = useSelector(selectIsSuburban);
  const isDesktop = useSelector(selectIsDesktop);

  if (anchor) {
    return anchor;
  }

  if (isSuburban) {
    return isDesktop ? EScrollingBlocks.MarketPrice : EScrollingBlocks.ObjectInfo;
  }

  return EScrollingBlocks.DealTypeTabs;
}

/**
 * Автоскролл при первом переходе на страницу оценки
 * Скролл к якорю anchor из query параметров (если есть), или к блоку результатов оценки (дефолт)
 * Скроллим только страницы оценки для поискуна и генерацию отчета (оценка для риелтора)
 * Страницу готового отчета не скролим
 * Если поискун/соб пришли из КО - не скролим
 */
export function useFirstScrollControl() {
  const [done, setDone] = React.useState(false);
  const isReportDefaultStatus = useIsReportStatusDefault();
  const isSearcherFromOfferCard = useIsSearcherFromOfferCard();
  const scrollToBlock = useScrollToBlock();
  const { refBlocksState } = React.useContext(scrollingContext);
  const block = useGetScrollBlock();

  React.useEffect(() => {
    if (!done && !isSearcherFromOfferCard && isReportDefaultStatus && refBlocksState[block]) {
      setTimeout(() => scrollToBlock(block));
      setDone(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [done, refBlocksState]);
}
